import { defaultDropAnimationSideEffects, DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type NodeOverlayProps = {
  readonly children: ReactNode;
};

export const NodeOverlay = ({ children }: NodeOverlayProps) => {
  const dropAnimation = {
    sideEffects: defaultDropAnimationSideEffects({
      styles: {
        active: {
          opacity: '1',
        },
      },
    }),
  };
  return createPortal(
    <DragOverlay dropAnimation={dropAnimation} modifiers={[restrictToWindowEdges]}>
      {children}
    </DragOverlay>,
    document.body,
  );
};

NodeOverlay.displayName = 'NodeOverlay';
